import React, { useState } from "react";
import api from "../api";
import "../App.css";

const Login = () => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // 예전에는 GET 이라 아이디·비밀번호가 주소와 접속로그에 그대로 남았다. POST 로 보낸다.
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await api.post("/auth/login", { id, pw });
      if (res.data.status) window.location.href = "/main";
      else setError(res.data.comment || "로그인에 실패했습니다.");
    } catch (err) {
      setError("서버에 연결할 수 없습니다.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="login-form" onSubmit={submit}>
        <h1 className="tobe">TOBE</h1>
        <h2 className="sms">문자발송</h2>
        <label>아이디</label>
        <input value={id} onChange={(e) => setId(e.target.value)} autoFocus />
        <label>패스워드</label>
        <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} />
        <button className="btn primary" disabled={busy}>{busy ? "확인 중…" : "로그인"}</button>
        {error && <span className="err">{error}</span>}
      </form>
    </div>
  );
};

export default Login;
